/**
 * CR-8713: one dropdown entry per name.
 *
 * Each customer site owns its own Sources of Rejection, and a site cannot hold
 * the same name twice. A Helix admin with no customer in view (All Companies)
 * is sent every site's list, so "Stock" came back once per customer. The NCR
 * cannot be saved without a customer in view, so which site's row is kept does
 * not matter there; for everyone else the list is already one site's.
 *
 * @param options - the options in display order
 * @returns the first option for each name, compared ignoring case and spaces
 */
export function uniqueByName<T extends { name: string }>(options: T[]): T[] {
  const seen = new Set<string>();
  return options.filter((option) => {
    const key = option.name.trim().toLocaleLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
